import script from "./ReferencesIndex.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReferencesIndex.vue?vue&type=script&lang=ts&setup=true"

import "./ReferencesIndex.vue?vue&type=style&index=0&id=6b13ab34&lang=scss"

const __exports__ = script;

export default __exports__